import { responsiveFontSizes } from '@mui/material'
import { createTheme } from '@mui/material/styles'
import { APP_THEME_COLORS } from './colors'

export const theme = responsiveFontSizes(
  createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
    palette: {
      primary: {
        main: APP_THEME_COLORS[30],
        contrastText: APP_THEME_COLORS[10],
      },
      secondary: {
        main: APP_THEME_COLORS[40],
        contrastText: APP_THEME_COLORS[20],
      },
      grey: {
        main: APP_THEME_COLORS[50],
      },
    },
    typography: {
      fontFamily: 'FSEmeric-Regular',
      h4: { fontFamily: 'FSEmeric-Medium' },
      h5: { fontFamily: 'FSEmeric-Medium' },
      h6: {
        fontFamily: 'FSEmeric-Medium',
        lineHeight: 1,
      },
      subtitle1: {
        fontFamily: 'FSEmeric-Medium',
        lineHeight: 1.25,
      },
      body1: { lineHeight: 1.25 },
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            height: 48,
            backgroundColor: '#0000000A',
          },
          input: {
            height: '-webkit-fill-available',
            fontSize: 16,
            fontFamily: 'FSEmeric-Regular',
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            '&:-webkit-autofill': {
              height: '10px',
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontFamily: 'FSEmeric-Medium',
          },
        },
      },
      MuiAccordionSummary: {
        styleOverrides: {
          content: {
            display: 'block',
            '&.Mui-expanded': {
              margin: '12px 0',
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          elevation1: {
            boxShadow: 'none',
          },
        },
      },
    },
  })
)
